import { render, staticRenderFns } from "./clBookingBasic.vue?vue&type=template&id=01ece07a&scoped=true&"
import script from "./clBookingBasic.vue?vue&type=script&lang=js&"
export * from "./clBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./clBookingBasic.vue?vue&type=style&index=0&id=01ece07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ece07a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ece07a')) {
      api.createRecord('01ece07a', component.options)
    } else {
      api.reload('01ece07a', component.options)
    }
    module.hot.accept("./clBookingBasic.vue?vue&type=template&id=01ece07a&scoped=true&", function () {
      api.rerender('01ece07a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/clBookingBasic.vue"
export default component.exports